module.exports = __webpack_public_path__ + "static/killstress-dark-b0722e891a1f1bd028a95589579281d7.gif";